// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../index';

import { gql } from 'graphql-tag';
import { MeFragmentDoc } from '../../fragments/me.fragment.generated';
export const LoginResponseSuccessFragmentDoc = gql`
    fragment loginResponseSuccess on LoginResponseSuccess {
  __typename
  jwt
  user {
    ...me
  }
}
    ${MeFragmentDoc}`;